module.exports = __webpack_public_path__ + "static/media/me-you-us.810be46b.png";